import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBTextArea } from '_components';
import styles from './Common.module.css';

const components = {

}

class PatientCareCenterNoteObjectiveNeuroSynergies extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {

        return (
            <PatientCareCenterNoteSection id='neuro_syn' name='Synergies' level={2} noChildPadding={true}>
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEPEDS'
                    entityKeyColumn='OPNO'
                    entityKeyValue={this.props.opno}
                    field='OPSYNERGIES'
                    className={styles.textarea}
                />
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveNeuroSynergies = connect(mapStateToProps)(PatientCareCenterNoteObjectiveNeuroSynergies);
export { connectedPatientCareCenterNoteObjectiveNeuroSynergies as PatientCareCenterNoteObjectiveNeuroSynergies };

